@let unread = (unreadCount$ | async) ?? 0;

<button
  mat-icon-button
  class="bell-button"
  [matMenuTriggerFor]="notifMenu"
  (menuOpened)="onOpened()"
  matBadgeColor="warn"
  matBadgeSize="small"
  [matBadge]="unread"
  [matBadgeHidden]="unread === 0"
  [attr.aria-label]="unread > 0 ? 'Notifications, ' + unread + ' new' : 'Notifications'">
  <mat-icon>notifications</mat-icon>
</button>

<mat-menu #notifMenu="matMenu" class="notif-menu" xPosition="before">
  <div class="notif-header" (click)="$event.stopPropagation()">
    <span class="notif-title">Notifications</span>
    @if (unread > 0) {
      <button mat-button class="notif-mark-all" (click)="markAllRead($event)">Mark all read</button>
    }
  </div>

  @let items = (notifications$ | async) ?? [];
  @if (items.length === 0) {
    <div class="notif-empty">
      <mat-icon>notifications_none</mat-icon>
      <span>No notifications yet.</span>
    </div>
  } @else {
    @for (n of items; track n.id) {
      <button mat-menu-item class="notif-item" [ngClass]="{ unread: !n.isRead }" (click)="onNotificationClick(n)">
        <mat-icon [ngClass]="'notif-icon-' + (n.type || 'default')">{{ iconFor(n.type) }}</mat-icon>
        <div class="notif-body">
          <span class="notif-message">{{ n.message }}</span>
          <span class="notif-date">{{ n.createdAt | date:'medium' }}</span>
        </div>
        @if (!n.isRead) {
          <span class="notif-dot" aria-hidden="true"></span>
        }
      </button>
    }
  }
</mat-menu>
